import React, { useEffect } from "react"
import { Form, Input } from "antd"
import { SemiBoldLabelText, MediumText } from "@/UI"
import { useTranslation } from "react-i18next"
import { OrgProviderCredentials, IAuthFields } from "@/types/organization-providers"
import { get, isEmpty } from "lodash"

interface ProviderAuthInputsProps {
  isEditing: boolean
  authFields?: IAuthFields[]
  organizationCredentials?: OrgProviderCredentials
}

const ProviderAuthInputs: React.FC<ProviderAuthInputsProps> = ({
  organizationCredentials,
  authFields,
  isEditing,
}) => {
  const { t } = useTranslation()

  useEffect(() => {}, [organizationCredentials])

  const inputTexts: Record<string, { label: string; placeholder: string }> = {
    customerId: {
      placeholder: t("profile.ProviderAuthInputs.enterYourCustomerId"),
      label: t("common.customerId"),
    },
    orgId: {
      placeholder: t("profile.ProviderAuthInputs.enterYourOrganizationId"),
      label: t("common.organizationId"),
    },
    email: {
      placeholder: t("profile.ProviderAuthInputs.enterYourAccountEmail"),
      label: t("common.email"),
    },
    password: {
      placeholder: t("profile.ProviderAuthInputs.enterYourAccountPassword"),
      label: t("common.password"),
    },
    apiKey: {
      placeholder: t("profile.ProviderAuthInputs.enterYourAccountApiKey"),
      label: t("common.apiKey"),
    },
    clientSecret: {
      placeholder: t("profile.ProviderAuthInputs.enterYourApiClientSecret"),
      label: t("common.apiSecret"),
    },
    keyId: {
      placeholder: t("profile.ProviderAuthInputs.enterYourKeyId"),
      label: t("common.keyId"),
    },
    clientId: {
      placeholder: t("profile.ProviderAuthInputs.enterYourApiClientId"),
      label: t("common.clientId"),
    },
    username: {
      placeholder: t("profile.ProviderAuthInputs.enterYourUsername"),
      label: t("common.username"),
    },
    privateKey: {
      placeholder: t("profile.ProviderAuthInputs.enterYourPrivateKey"),
      label: t("common.privateKey"),
    },
  }

  // Temporary: auth method not handlede yet
  if (isEmpty(authFields)) {
    return (
      <MediumText>
        Sorry, using your own account with this provider will be available soon
      </MediumText>
    )
  }

  return (
    <div id="provider-api-keys-form">
      {authFields?.map(({ key, obfuscated, isText, invisible }) => {
        if (invisible) return <></>
        const keyValue = get(organizationCredentials, key)
        const texts = get(inputTexts, key)

        return (
          <div key={key}>
            <SemiBoldLabelText>{texts?.label}</SemiBoldLabelText>
            <Form.Item
              name={key}
              rules={[
                {
                  required: true,
                  message: "This field is mandatory",
                },
              ]}
            >
              {obfuscated ? (
                <Input.Password
                  size="large"
                  name={key}
                  className="profile-input"
                  placeholder={texts?.placeholder}
                  defaultValue={keyValue}
                  value={keyValue}
                  disabled={!isEditing && !!keyValue}
                  autoComplete="off"
                  type="new-password"
                />
              ) : isText ? (
                <Input.TextArea
                  size="large"
                  name={key}
                  className="profile-input"
                  defaultValue={keyValue}
                  value={keyValue}
                  disabled={!isEditing && !!keyValue}
                  autoComplete="off"
                  style={{ color: "transparent", textShadow: "0 0 8px rgba(0,0,0,0.5)" }}
                />
              ) : (
                <Input
                  size="large"
                  name={key}
                  className="profile-input"
                  placeholder={texts?.placeholder}
                  defaultValue={keyValue}
                  value={keyValue}
                  disabled={!isEditing && !!keyValue}
                  autoComplete="off"
                  type="new-password"
                />
              )}
            </Form.Item>
          </div>
        )
      })}
    </div>
  )
}

export default ProviderAuthInputs
